import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { SettingsPanelAccordionItem } from './settings-panel-accordion-item';

type Props = PropsWithChildren<{
  startingValue?: string;
}>;

export const SettingsPanelAccordion = ({ children, startingValue }: Props) => {
  return (
    <Accordion
      css={{
        borderBottom: `solid 1px ${theme.colors.neutral20}`,
        '& button[data-active="true"]': { borderBottomColor: 'transparent' },
      }}
      startingValue={startingValue}
      variant='blank'
    >
      {children}
    </Accordion>
  );
};

SettingsPanelAccordion.Item = SettingsPanelAccordionItem;
